export const BUILTIN_LETTERS = [
  {
    id: "appointment",
    name: "Appointment Letter",
    title: "Appointment Letter",
    subject: "Appointment to the position of [Position]",
    content: `Dear [Employee name],

We are pleased to offer you an appointment with [Company name] as [Position], subject to the terms discussed with you and the applicable company policies.

Your proposed date of joining is [Joining date]. Further details regarding your role, compensation, reporting arrangements and conditions of employment may be recorded separately.

Please review this draft and confirm the details before it is issued.

Sincerely,`,
  },
  {
    id: "resignation",
    name: "Resignation Letter",
    title: "Resignation Letter",
    subject: "Resignation from the position of [Position]",
    content: `Dear [Manager / HR contact],

I am writing to formally submit my resignation from my position as [Position] at [Company name]. My proposed final working day is [Date], subject to confirmation of the applicable notice arrangements.

Thank you for the opportunities and experience during my time with the company. I will coordinate the handover of my responsibilities before my departure.

Regards,`,
    signatory_designation: "Employee",
  },
  {
    id: "termination",
    name: "Termination Letter",
    title: "Employment Separation Letter",
    subject: "Employment separation",
    content: `Dear [Employee name],

This letter records the company’s communication regarding the end of your employment with [Company name], effective [Effective date]. Please refer to the relevant employment records and company contact for details about the next steps.

Please review the wording and all particulars with the appropriate company representative before this letter is issued.

Sincerely,`,
  },
  {
    id: "other",
    name: "Other Letter",
    title: "",
    subject: "",
    content: "",
  },
];

export const EMPTY_LETTER = {
  letter_type: "",
  title: "",
  letter_date: new Date().toLocaleDateString("en-CA"),
  recipient_name: "",
  recipient_address: "",
  subject: "",
  content: "",
  signatory_name: "",
  signatory_designation: "",
  signature: null,
  attachment: null,
};

export function validateUpload(file, kind) {
  if (!file) return "";
  const allowed = kind === "signature"
    ? ["image/png", "image/jpeg"]
    : ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "image/png", "image/jpeg"];
  const maxBytes = kind === "signature" ? 200 * 1024 : 5 * 1024 * 1024;
  if (!allowed.includes(file.type)) return kind === "signature"
    ? "Choose a PNG or JPEG signature image."
    : "Choose a PDF, DOCX, PNG or JPEG attachment.";
  if (file.size > maxBytes) return kind === "signature"
    ? "Signature images must be 200 KB or smaller."
    : "Attachments must be 5 MB or smaller.";
  return "";
}

export function readFileDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("Could not read this file."));
    reader.readAsDataURL(file);
  });
}

export function dataUrlBase64(value) {
  return value ? String(value).split(",")[1] || "" : "";
}

export function hasAttachment(record) {
  return !!(record?.attachment || record?.has_attachment);
}

export function dateInput(value) {
  if (!value) return "";
  return String(value).slice(0, 10);
}

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename || "document";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}